import { z } from "zod";

export const logInFormSchema = z.object({
  email: z.email(),
  password: z.string().min(3),
});

export type LogInFormValues = z.infer<typeof logInFormSchema>;

export const setPasswordFormSchema = logInFormSchema.pick({password: true})

export type SetPasswordFormValues = z.infer<typeof setPasswordFormSchema>;
